import React, { useState, useRef, useEffect, useId } from 'react';
import { Link, useLocation } from 'react-router-dom';
import style from './desktopNav.module.scss';

/** Same case study routes as `FeaturedProjectShowcase` on the Portfolio page */
const PORTFOLIO_CASE_STUDIES = [
  {
    to: '/NBNB',
    label: 'NBNB',
  },
  {
    to: '/disability-claims',
    label: 'VA Disability Claim',
  },
  {
    to: '/CampusDive',
    label: 'Campus Dive',
  },
  {
    to: '/MHA',
    label: 'MHA',
  },
];

const PORTFOLIO_PATHS = new Set(['/portfolio', ...PORTFOLIO_CASE_STUDIES.map((c) => c.to)]);

export default function DesktopNav() {
    const location = useLocation();
    const [subNavIsOpen, setSubNavIsOpen] = useState(false);
    const node = useRef();
    const menuId = useId();
  
    useEffect(() => {
      document.addEventListener('mousedown', clickOutside);
      return () => {
        document.removeEventListener('mousedown', clickOutside);
      }
    }, [subNavIsOpen])
        
    const clickOutside = (e) => {
      if (!node.current?.contains(e.target)) {
        setSubNavIsOpen(false)
      }
    }

    const handleClick = () =>{
      setSubNavIsOpen(false)
    }

    const portfolioActive = PORTFOLIO_PATHS.has(location.pathname);
    const aboutActive = location.pathname === '/about';
    const resumeActive = location.pathname === '/resume';

    const navClass = (active) => (active ? `${style.navLink} ${style.navLinkActive}` : style.navLink);

    return (
      <nav className={style.navWrapper} aria-label="Main">
        <ul className={style.mainNav}  ref={node}>
            <li className={`${style.headerLI} ${style.portfolioItem}`}>
              <div className={style.portfolioRow}>
                <Link to="/portfolio" onClick={handleClick} className={navClass(portfolioActive)}>Portfolio</Link>
                <button
                  type="button"
                  className={style.portfolioMenuButton}
                  aria-expanded={subNavIsOpen}
                  aria-haspopup="true"
                  aria-controls={menuId}
                  id={`${menuId}-trigger`}
                  onClick={() => setSubNavIsOpen((o) => !o)}
                  onKeyDown={(e) => {
                    if (e.key === 'Escape') setSubNavIsOpen(false);
                  }}
                >
                  <span className={style.srOnly}>Open portfolio case studies</span>
                  <svg
                    className={`${style.portfolioCaret} ${subNavIsOpen ? style.portfolioCaretOpen : ''}`}
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden
                    focusable="false"
                  >
                    <path
                      d="M6 9l6 6 6-6"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
              {subNavIsOpen ? (
                <ul className={style.portfolioDropdown} id={menuId} role="menu" aria-labelledby={`${menuId}-trigger`}>
                  {PORTFOLIO_CASE_STUDIES.map(({ to, label }) => (
                    <li key={to} role="none">
                      <Link role="menuitem" to={to} className={style.portfolioDropdownLink} onClick={handleClick}>
                        {label}
                      </Link>
                    </li>
                  ))}
                </ul>
              ) : null}
            </li>
            <li className={style.headerLI}><Link onClick={handleClick} to="/about" className={navClass(aboutActive)}>About</Link></li>
            <li className={style.headerLI}><Link onClick={handleClick} to="/resume" className={navClass(resumeActive)}>Résumé</Link></li>
        </ul>

      </nav>
    )
  }

